﻿import { FavoriteSessionObject, Guid, SearchContextEnum } from './Types';
import { isLoggedIn } from '@SharedScripts/UserData/Authentication';

export function assertFavoriteSessionObject(x: any): asserts x is FavoriteSessionObject {
  if (!x
    || typeof x !== 'object'
    || typeof x.type !== 'string'
    || !Object.values(SearchContextEnum).includes(x.type)
    || typeof x.id !== 'string') {
    throw new Error(`Invalid FavoriteSessionObject: ${x}`);
  }
}

export function assertGuid(guid: string): asserts guid is Guid {
  const guidPattern = /(^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$)|^[0-9a-fA-F]{32}$/;
  if (!guidPattern.test(guid)) {
    throw new Error(`Provided string '${guid}' is not a GUID`);
  }
}

export async function assertLoggedIn() {
  const loggedIn = await isLoggedIn();
  if (!loggedIn) {
    throw new Error('User is not logged in');
  }
}

export function assertNever(x: never): never {
  throw new Error(`Unhandled case ${x}`);
}
